"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAutomationModalBody = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("Library/AutomationLibrary/DeleteAutomationModal.css"));
var deleteAutomationProperties = [
    {
        icon: react_1.default.createElement(icons_1.RemoveTemplate, null),
        description: react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "All templates with this automation assigned impacted."),
    },
    {
        icon: react_1.default.createElement(icons_1.Page, null),
        description: react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Pages created from this template impacted."),
    },
    {
        icon: react_1.default.createElement(icons_1.HelpLite, null),
        description: (react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/category/836-automations" }, "Learn More"),
            " about Qwilr’s automations.")),
    },
];
var DeleteAutomationModalBody = function (_a) {
    var automation = _a.automation;
    return (react_1.default.createElement("div", { className: "space-stack-m" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3", className: styles.heading }, "Delete automation?"),
        react_1.default.createElement("div", { className: "space-stack-m" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                "Deleting an automation is permanent and cannot be recovered. Once deleted,",
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, " ".concat(automation.name)),
                " ",
                "will be removed from templates it is assigned to, and no longer run on any pages.")),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.checklist }, deleteAutomationProperties.map(function (property, index) { return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", className: styles.items },
            react_1.default.createElement("div", { className: styles.icon }, property.icon),
            react_1.default.createElement("div", { className: styles.description }, property.description))); }))));
};
exports.DeleteAutomationModalBody = DeleteAutomationModalBody;
